import { get, post } from './axios.js'

/**
 *  - /tempo/tempoEdit
 * @returns
 */
export async function tempoEdit(params = {}) {
  try {
    const result = await post('/tempo/tempoEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 *  - /tempo/tempoList
 * @returns
 */
export async function tempoList(params = {}) {
  try {
    const result = await post('/tempo/tempoList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}
